/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * Risk benchmark categories for comparison to population average
 */
export type BenchmarkCategory = typeof BenchmarkCategory[keyof typeof BenchmarkCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BenchmarkCategory = {
  Below_average: 'Below average',
  Average: 'Average',
  Above_average: 'Above average',
} as const;
